import clsx from 'clsx';
import { FC, ReactNode } from 'react';

export const FilterName: FC<{ icon: ReactNode; label: string; showNotificationBadge?: boolean }> = ({
  icon,
  label,
  showNotificationBadge,
}) => (
  <div className="grid grid-cols-[24px_1fr] gap-4">
    {icon}
    <span className={clsx('c-fs-body1', 'font-extrabold')}>{label}</span>
    {showNotificationBadge && (
      <span
        className="absolute top-1/2 right-12 -mt-1 h-2 w-2 rounded-full bg-for-pri-acc"
        data-testid={`${label}-filter-notification`}
      />
    )}
  </div>
);
